import { Col, Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";
import Header from "shared/components/Header";

const Create = ({ cancel, onSubmit }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.REMINDER);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("CREATE.FORM", { returnObjects: true });

  return (
    <>
      <Header key={"header"} title={CREATE.TITLE} />
      <div className="reminder-form--wrapper">
        <Formik
          initialValues={{ content: "" }}
          onSubmit={onSubmit}
          validationSchema={validation(
            t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
          )}
        >
          {({ isValid, handleSubmit, setFieldValue, ...formProps }) => [
            <Row gutter={[16, 16]} key="card">
              <Col lg={24} xs={24}>
                <Card title={CREATE.TITLE}>
                  <Form type="vertical">
                    <Row gutter={[16, 16]} key={"row"}>
                      <Col lg={24}>
                        <Input
                          label={FORM.CONTENT}
                          placeholder={FORM.CONTENT}
                          {...bindInputProps({ name: "content", ...formProps })}
                        />
                      </Col>
                      <Col lg={24}>
                        <Input
                          name="scheduledDate"
                          type="date"
                          label={FORM.DATE}
                          onChange={(_, __) =>
                            setFieldValue("scheduledDate", _)
                          }
                          showTime
                          /*disabledDateTime={() => ({
                          disabledHours: () => {},
                          disabledMinutes: () => {},
                          disabledSeconds: () => {},
                        })}*/
                        />
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </Col>
              <Col lg={24} xs={24}>
                <Row flex="">
                  <Col span={8}>
                    <Button type="secondary--light" onClick={cancel}>
                      {CREATE.ACTIONS.CANCEL}
                    </Button>
                  </Col>
                  <Col span={8} offset={8}>
                    <Row align="end">
                      <Button type="primary" onClick={handleSubmit}>
                        {CREATE.ACTIONS.SAVE}
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>,
          ]}
        </Formik>
      </div>
    </>
  );
};

export default Create;
